import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AbstractLazyDirective } from '@bn/shared/entities/abstracts/abstract-lazy.directive';
import { UploadFileComponent } from '@bn/web-ui/upload-file/upload-file.component';

export interface OpenApiUploadResult {
  action: 'upload' | 'cancel';
  file?: File;
}

@Component({
  selector: 'app-shield-openapi-upload-modal',
  templateUrl: './shield-openapi-upload-modal.component.html',
  styleUrls: ['./shield-openapi-upload-modal.component.scss'],
  imports: [FormsModule, UploadFileComponent, FaIconComponent],
  standalone: true,
})
export class ShieldOpenApiUploadModalComponent extends AbstractLazyDirective {
  readonly #dialog = inject<BsModalRef<ShieldOpenApiUploadModalComponent>>(BsModalRef);

  private readonly onAction = new Subject<OpenApiUploadResult>();

  selectedFile: File | null = null;

  constructor() {
    super();

    this.subscriptions.add(this.#dialog.onHide?.subscribe((event) => (event === 'backdrop-click' || event === 'esc' ? this.onClose() : undefined)));
  }

  onFileSelected(files: File[]): void {
    if (files?.length) {
      this.selectedFile = files[0];
      this.onAction.next({
        action: 'upload',
        file: this.selectedFile,
      });
      this.#dialog.hide();
    }
  }

  onClose(): void {
    this.onAction.next({ action: 'cancel' });
    this.#dialog.hide();
  }

  getOnAction$(): Observable<OpenApiUploadResult> {
    return this.onAction.asObservable();
  }
}
